<mat-toolbar color="primary">
    <span class="title-center">{{title}}</span>
</mat-toolbar>
<div [ngClass]='isVerifyGS?" verifyingOrgInfoPanel":" editingOrgInfoPanel"'>
    <form [formGroup]="einOrgForm" class="form-content
        max-md:overflow-x-scroll">
        <h4 class="items-center content-center"><b>{{isEditMode?"Exception
                Organization Info":"Guidestar Organization Info"}}</b></h4>
        <div class="flex flex-col">
            <mat-form-field>
                <input type="text" matInput required maxlength="10"
                    placeholder="EIN" formControlName="ein"
                    [readonly]='!isEditMode' EIN ngControl="EIN">
                <!-- <mat-hint>Example: 12-1234567</mat-hint> -->
            </mat-form-field>
            <mat-form-field>
                <input type="text" matInput required maxlength="50"
                    placeholder="Organization Name"
                    [readonly]='!isEditMode'
                    formControlName="organization_name">
            </mat-form-field>
            <mat-form-field>
                <input type="text" matInput required maxlength="35"
                    placeholder="Address1" [readonly]='!isEditMode'
                    formControlName="address_line1">
            </mat-form-field>
            <mat-form-field>
                <input type="text" matInput maxlength="35"
                    placeholder="Address2" [readonly]='!isEditMode'
                    formControlName="address_line2">
            </mat-form-field>
            <mat-form-field>
                <input type="text" matInput required maxlength="50"
                    placeholder="City" [readonly]='!isEditMode'
                    formControlName="city">
            </mat-form-field>
            <mat-form-field>
                <mat-select required maxlength="10" placeholder="State"
                    [disabled]='!isEditMode'
                    formControlName="state">
                    <mat-option value="">--</mat-option>
                    <mat-option *ngFor="let state of states"
                        [value]="state">{{state}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field>
                <input type="text" matInput required maxlength="9"
                    placeholder="Zip Code" formControlName="zip"
                    [readonly]='!isEditMode'>
            </mat-form-field>
            <mat-form-field>
                <mat-select maxlength="10" placeholder="Tax Exempt Status"
                    formControlName="subsection_501">
                    <mat-option *ngFor="let subsection of taxExcemptList"
                        [value]="subsection">
                        {{getTaxExemptStatus(subsection)}}</mat-option>
                </mat-select>
            </mat-form-field>
            <div *ngIf="this.einOrgForm.value.einOrgInfoId !== null">
                <mat-form-field class="!w-full">
                    <input type="text" matInput required maxlength="9"
                        placeholder="Last Verify Date"
                        [value]="this.einOrgForm.value.lastUpdated | date:
                        'MM-dd-yyyy h:mm:ss a'" readonly>
                </mat-form-field>
            </div>
            <div class="buttons !w-full grid" *ngIf="isVerifyGS">
                <button mat-raised-button
                    (click)="onUpdate(false)"
                    color="primary"
                    [disabled]="einOrgForm.invalid">Renew/Save exception Org
                    Info</button>
            </div>
        </div>
    </form>
    <form [formGroup]="einOrgGuideStar" class="form-content
        max-md:overflow-x-scroll"
        *ngIf="isVerifyGS">
        <h4 class="items-center content-center"
            [style.color]="showError?'red':'black'"><b>{{showError?
                errorMessage: "Guidestar Organization Info"}}</b></h4>
        <!-- <div class="error"
            *ngIf="showError" style="color:red">
            {{errorMessage}}
        </div> -->
        <div *ngIf="!showError &&
            !isLoading">
            <mat-form-field>
                <input type="text" matInput required maxlength="10"
                    placeholder="EIN" formControlName="ein"
                    readonly EIN ngControl="EIN">
                <!-- <mat-hint>Hint: 12-1234567</mat-hint> -->
            </mat-form-field>
            <mat-form-field>
                <input type="text" matInput required maxlength="50"
                    placeholder="Organization Name"
                    readonly formControlName="organization_name">
            </mat-form-field>
            <mat-form-field>
                <input type="text" matInput required maxlength="35"
                    placeholder="Address1" readonly
                    formControlName="address_line1">
            </mat-form-field>
            <mat-form-field>
                <input type="text" matInput maxlength="35"
                    placeholder="Address2" readonly
                    formControlName="address_line2">
            </mat-form-field>
            <mat-form-field>
                <input type="text" matInput required maxlength="50"
                    placeholder="City" readonly
                    formControlName="city">
            </mat-form-field>
            <mat-form-field>
                <mat-select required maxlength="10" placeholder="State"
                    [disabled]='!isEditMode'
                    formControlName="state">
                    <mat-option value="">--</mat-option>
                    <mat-option *ngFor="let state of states"
                        [value]="state">{{state}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field>
                <input type="text" matInput required maxlength="9"
                    placeholder="Zip Code" formControlName="zip"
                    readonly>
            </mat-form-field>
            <mat-form-field>
                <mat-select maxlength="10" placeholder="Tax Exempt Status"
                    formControlName="subsection_501">
                    <mat-option *ngFor="let subsection of taxExcemptList"
                        [value]="subsection">
                        {{getTaxExemptStatus(subsection)}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field>
                <input type="text" matInput required maxlength="9"
                    placeholder="Last Verify Date"
                    [value]="this.einOrgGuideStar.value.lastUpdated | date:
                    'MM-dd-yyyy h:mm:ss a'" readonly>
            </mat-form-field>

            <div class="buttons !w-full grid"*ngIf="isVerifyGS">
                <button mat-raised-button (click)="onUpdate(true)"
                    class="justify-center items-center content-center"
                    color="primary"
                    [disabled]="einOrgGuideStar.invalid">Save Guidestar Org
                    Info</button>
            </div>
        </div>
    </form>
</div>
<div class="rounded-b-2xl w-full flex flex-col items-center content-center
    justify-center" *ngIf="isEditMode" class="buttons"
    fxLayout="row"
    fxLayoutAlign="center center">
    <button mat-raised-button color="warn" (click)="onCancel()">Cancel</button>
    <button *ngIf="!isVerifyGS && this.einOrgForm.value.einOrgInfoId !== null"
        mat-raised-button
        (click)="onUpdate(false)" color="primary"
        [disabled]="einOrgForm.invalid">Update</button>
    <button *ngIf="!isVerifyGS && this.einOrgForm.value.einOrgInfoId === null"
        mat-raised-button
        (click)="onSave()" color="primary" [disabled]="einOrgForm.invalid">Save</button>
</div>